import { createIcon } from '@chakra-ui/icons';

// using `path`
export const BellRinging = createIcon({
  displayName: 'BellRinging',
  viewBox: '0 0 28 28',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.14672 12.25C6.14672 11.2187 6.34985 10.1975 6.74451 9.24471C7.13916 8.29193 7.71762 7.42621 8.44685 6.69698C9.17608 5.96775 10.0418 5.38929 10.9946 4.99463C11.9474 4.59998 12.9686 4.39685 13.9998 4.39685C15.0311 4.39685 16.0523 4.59998 17.0051 4.99463C17.9579 5.38929 18.8236 5.96775 19.5528 6.69698C20.2821 7.42621 20.8605 8.29193 21.2552 9.24471C21.6498 10.1975 21.853 11.2187 21.853 12.25V12.25C21.853 16.1656 22.6733 18.4406 23.3952 19.6875C23.4718 19.8203 23.5123 19.9709 23.5124 20.1242C23.5125 20.2775 23.4724 20.4282 23.3959 20.5611C23.3195 20.6941 23.2095 20.8046 23.0769 20.8816C22.9443 20.9586 22.7938 20.9994 22.6405 21H5.35922C5.20589 20.9994 5.05539 20.9586 4.9228 20.8816C4.79022 20.8046 4.68019 20.6941 4.60376 20.5611C4.52733 20.4282 4.48717 20.2775 4.48731 20.1242C4.48744 19.9709 4.52787 19.8203 4.60454 19.6875C5.32641 18.4406 6.14672 16.1656 6.14672 12.25Z"
        stroke="#49536E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 21V21.875C10.5 22.8033 10.8687 23.6935 11.5251 24.3499C12.1815 25.0063 13.0717 25.375 14 25.375C14.9283 25.375 15.8185 25.0063 16.4749 24.3499C17.1313 23.6935 17.5 22.8033 17.5 21.875V21"
        stroke="#49536E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0596 2.625C21.8411 3.74961 23.279 5.34261 24.2158 7.22969"
        stroke="#49536E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.78418 7.22969C4.721 5.34261 6.15887 3.74961 7.94043 2.625"
        stroke="#49536E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});
